// extracted by mini-css-extract-plugin
export var accordion = "_bl-0";
export var chevron = "_bl-3";
export var closed = "_bl-2";
export var content = "_bl-4";
export var open = "_bl-1";
export var rotate = "_bl-5";